<span *ngIf="tag" class="tone-tag-cell__tag" [ngClass]="'tone-tag-cell__tag--' + tag.tone">{{ tag.label }}</span>
